import { Outlet } from "react-router-dom";

export default function Home() {
  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-50">     
      <Outlet />
    </div>
  );
}